import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ListaDespesasLayer from "../components/ListaDespesasLayer";
import { useTranslation } from "../i18n/I18nContext";

const DespesasPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("despesa.breadcrumb.list")} />
      <ListaDespesasLayer />
    </MasterLayout>
  );
};

export default DespesasPage;
